module.exports = __webpack_public_path__ + "static/img/advertisement1.dd76502b.png";